
export function GetTwoToneGradient(
    color1: string,
    color2: string,
    angle: number = 45
) {
    return `linear-gradient(${angle}deg, ${color1} 25%, ${color2} 25%, ${color2} 50%, ${color1} 50%, ${color1} 75%, ${color2} 75%, ${color2} 100%)`;
}

export function GetSmoothTwoToneGradient(
    color1: string,
    color2: string,
    angle: number = 45
) {
    return `linear-gradient(90deg, rgb(3 12 34 / 38%) 0%, transparent 24%, rgb(255 255 255 / 10%) 52%, transparent 76%, rgb(2 8 28 / 36%) 100%), linear-gradient(${angle}deg, ${color1} 0%, ${color2} 100%)`;
}
